import moment from 'moment';
import * as R from 'ramda';
import angular from 'angular';


export default function SettingsDialogController(
  $q,
  $scope,
  $rootScope,
  alerts,
  confirmDialog,
  loaderService,
  orgDataService,
  orgSharedModelService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
  editVendorManagerDialog,
  editCustomRiskControlDialog
) {
  const vm = this;

  vm.handleExpandSettingsSection = _handleExpandSettingsSection;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditVendorManager = _handleEditVendorManager;
  vm.handleAddCustomRiskControl = _handleAddCustomRiskControl;
  vm.handleEditCustomRiskControl = _handleEditCustomRiskControl;
  vm.handleDeleteCustomRiskControl = _handleDeleteCustomRiskControl;
  vm.handleEditSettingsFormSubmit = _handleEditSettingsFormSubmit;
  vm.refreshVendors = _refreshVendors;
  // vm.refreshVendors = vmSharedModelService.refreshVendors;

  vm.today = moment().endOf('day');
  vm.yesterday = moment().endOf('day').subtract(1, 'day');
  vm.customerId = userService.user.customerId;
  vm.resetCustomerDataMode = 'delete';
  vm.newSettings = {
    ...vm.settings,
    lastBoardReviewDateMoment: vm.settings.lastBoardReviewDate ? moment(vm.settings.lastBoardReviewDate) : moment(),
    emailSuffix: vm.settings.emailSuffix || 'safenationalbank.com',
  };

  _activate();

  function _activate() {
    orgSharedModelService.getCustomer(vm.customerId, true)
      .then((customer) => {
        vm.showResetCustomerData = customer.canResetData;
      });
  }

  function _handleExpandSettingsSection($event, section) {
    if (!vm[`${section}IsLoaded`]) {
      if (section === 'riskCategoryWeight') {
        vmDataService.getRiskCategories().then((getRiskCategoryWeightResponse) => {
          vm.settings.riskCategories = angular.copy(getRiskCategoryWeightResponse.data.result);
          vm.newSettings.riskCategories = angular.copy(getRiskCategoryWeightResponse.data.result);
          vm[`${section}IsLoaded`] = true;
        });
      } else if (section === 'vendorManagers') {
        vmDataService.getVendorManagersByCustomer(
          userService.user.customerId
        ).then((getVendorManagersByCustomerResponse) => {
          vm.vendorManagers = getVendorManagersByCustomerResponse.data.result;

          vm.vendorManagersIsLoaded = true;
        });
      } else if (section === 'customRiskControls') {
        vmDataService.getCustomRiskControls(
          userService.user.customerId
        ).then((getCustomRiskControlsResponse) => {
          vm.newSettings.customRiskControls = getCustomRiskControlsResponse.data.result;
          vm.customRiskControlsIsLoaded = true;
        });
      }
    }
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.settingsDialog);
  }

  function _handleEditVendorManager($event, vendorManager) {
    vmDataService.getVendorManager(
      vendorManager.vendorManagerId
    ).then((getVendorManagerResponse) => {
      showEditVendorManagerDialog(
        {
          vendorManager: getVendorManagerResponse.data,
        },
        $event
      );
    });
  }
  function _refreshVendors() {
    // vmSharedModelService.refreshVendors();
  }

  function showEditVendorManagerDialog(data, $event) {
    ssDialogService.dialogs.vendorManagement.editVendorManagerDialog = ssDialogService.alert(
      editVendorManagerDialog.getOptions($event, {
        vendorManager: data.vendorManager,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editVendorManagerDialog);
  }

  function _handleAddCustomRiskControl($event) {
    showEditCustomRiskControlDialog(
      {
        settings: vm.newSettings,
        customRiskControl: {
          customerId: userService.user.customerId,
          riskControlId: -1,
        }
      },
      $event
    );
  }

  function showEditCustomRiskControlDialog(data, $event) {
    ssDialogService.dialogs.vendorManagement.editCustomRiskControlDialog = ssDialogService.alert(
      editCustomRiskControlDialog.getOptions($event, {
        settings: data.settings,
        customRiskControl: data.customRiskControl,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editCustomRiskControlDialog);
  }

  function _handleEditCustomRiskControl($event, customRiskControl) {
    loaderService.showViewLoader = true;
    vmDataService.getCustomRiskControlQuestions(
      customRiskControl.riskControlId
    ).then((getCustomRiskControlQuestionsResponse) => {
      customRiskControl.riskControlQuestions = getCustomRiskControlQuestionsResponse.data.result;
      loaderService.showViewLoader = false;

      showEditCustomRiskControlDialog(
        {
          settings: vm.newSettings,
          customRiskControl,
        },
        $event
      );
    });
  }

  function _handleDeleteCustomRiskControl($event, customRiskControl) {
    ssDialogService.dialogs.vendorManagement.deleteCustomRiskControlConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Custom Risk Control?',
        message: `Are you sure you want to delete the custom Risk Control "${customRiskControl.name}"?"`,
        handleYesClick() {
          _handleConfirmDelete(customRiskControl);
        },
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.vendorManagement.deleteCustomRiskControlConfirmDialog);
  }

  function _handleConfirmDelete(customRiskControl) {
    loaderService.showViewLoader = true;
    return vmDataService.deleteCustomRiskControl(customRiskControl.riskControlId)
      .then(() => {
        alerts.success(`The custom Risk Control "${customRiskControl.name}" has been successfully deleted.`);
        vm.newSettings.customRiskControls.splice(vm.newSettings.customRiskControls.indexOf(customRiskControl), 1);
        loaderService.showViewLoader = false;
        _closeDeleteCustomRiskControlDialog();
      }).catch(() => {
        alerts.error('An error occurred deleting the risk control.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteCustomRiskControlDialog();
  }

  function _closeDeleteCustomRiskControlDialog() {
    return ssDialogService.hide(
      ssDialogService.dialogs.vendorManagement.deleteCustomRiskControlConfirmDialog
    );
  }

  function _handleEditSettingsFormSubmit() {
    const saveRiskWeights = vm.riskCategoryWeightIsLoaded
      && !R.equals(vm.settings.riskCategories, vm.newSettings.riskCategories);

    if (saveRiskWeights) {
      ssDialogService.dialogs.vendorManagement.confirmSaveRiskWeightingsDialog = ssDialogService.alert(
        confirmDialog.getOptions(null, {
          dialogTitle: 'Save New Risk Category Weightings?',
          message: `The Risk Category Weightings that are used to determine the Inherent Risk Score for products have
            been changed. If you save the updated weightings, the Inherent Risk Score for all existing assessments
            will be updated to use these new weightings. Are you sure you wish to update these scores?`,
          handleYesClick: () => {
            _closeConfirmSaveRiskWeightingsDialog().then(() => {
              _saveSettings(saveRiskWeights);
            });
          },
          handleNoClick: _handleCancelSaveRiskWeightings,
        })
      );

      ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmSaveRiskWeightingsDialog);
    } else {
      _saveSettings(saveRiskWeights);
    }
  }

  function _handleCancelSaveRiskWeightings() {
    _closeConfirmSaveRiskWeightingsDialog();
  }

  function _closeConfirmSaveRiskWeightingsDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmSaveRiskWeightingsDialog);
  }

  function _saveSettings(saveRiskWeights) {
    if ($scope.editSettingsForm.$valid) {
      loaderService.showViewLoader = true;
      vm.newSettings.lastBoardReviewDate = vm.newSettings.lastBoardReviewDateMoment.format('MM/DD/YYYY');
      const dfdSaveSettings = vmDataService.saveSettings(vm.newSettings);
      const dfdSaveRiskCategoryWeights = $q.defer();

      if (saveRiskWeights) {
        const riskCategoryWeights = R.map((riskCategory) => {
          const riskCategoryWeight = riskCategory.riskCategoryWeights[0];
          riskCategoryWeight.riskCategoryWeightId = -1;
          riskCategoryWeight.riskCategoryId = riskCategory.riskCategoryId;
          return riskCategoryWeight;
        }, vm.newSettings.riskCategories);
        vmDataService.saveBulkRiskCategoryWeights(riskCategoryWeights)
          .then((saveBulkRiskCategoryWeightsResponse) => {
            dfdSaveRiskCategoryWeights.resolve(saveBulkRiskCategoryWeightsResponse.data);
          });
      } else {
        dfdSaveRiskCategoryWeights.resolve(false);
      }

      $q.all([
        dfdSaveSettings,
        dfdSaveRiskCategoryWeights.promise
      ]).then((allResponses) => {
        angular.extend(vmSharedModelService.vmSettings, allResponses[0].data);
        alerts.success('The Vendor Management settings have been saved successfully.');
        if (saveRiskWeights) {
          $rootScope.$broadcast('initVMPage');
        } else {
          $rootScope.$broadcast('refreshNotifications');
          $rootScope.$broadcast('settingsUpdated');
        }

        loaderService.showViewLoader = false;
        _closeDialog();
      });
    }
  }
}

SettingsDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'orgSharedModelService',
  'ssDialogService',
  'userService',
  'vmDataService',
  'vmSharedModelService',
  'editVendorManagerDialog',
  'editCustomRiskControlDialog',
];
